


























































































































import { Component, Vue, Prop, InjectReactive } from 'vue-property-decorator';
import { PaycheckForm } from './PaycheckForm';
import formatAmount from '@/filters/formatAmount';

@Component
export default class PaycheckEmployeeInfo extends Vue {
  @Prop({ type: Object, required: true }) private paycheck!: PaycheckForm;
  @InjectReactive() private isLocked!: boolean;
  @InjectReactive() private hasEditPermissions!: boolean;

  // TODO: When we have requirements to support other country paychecks, implement this to be read from bankAccounts.
  private bankAccountCountryCode = 'NO';
  private formatAmount = formatAmount

  private get taxExemptionDisplay() {
    if (this.paycheck.taxExemption && this.paycheck.taxExemptionAmountLimit) {
      return this.$t('Paycheck.taxExemptionUpTo', { limit: formatAmount(this.paycheck.taxExemptionAmountLimit)});
    } else if (this.paycheck.taxExemption) { // for old paychecks, before we had amount limit
      return this.$t('Yes');
    } else {
      return this.$t('No');
    }
  }
}
